import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_INGREDIENT_EXTRA_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateIngredientExtraDetailsArgs } from '../graphql/transformers'
import { UPDATE_INGREDIENT_EXTRA_DETAILS } from '../redux/action-types'

const useUpdateIngredientExtraDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isExtraDetailsLoading, extraDetailsError } = useSelector(
    store => store.ingredients.ingredient,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_INGREDIENT_EXTRA_DETAILS_MUTATION,
        { id, data: transformToUpdateIngredientExtraDetailsArgs(data) },
        dispatch,
        UPDATE_INGREDIENT_EXTRA_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isExtraDetailsLoading, error: extraDetailsError },
  ]
}

export default useUpdateIngredientExtraDetailsMutation
